var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"noun_chevron_right_1245238","data-name":"noun_chevron right_1245238","d":"M14.474,28a1.548,1.548,0,0,0,1.079-.432,1.442,1.442,0,0,0,0-2.087L3.683,14,15.553,2.519a1.442,1.442,0,0,0,0-2.087,1.562,1.562,0,0,0-2.158,0L.447,12.956a1.442,1.442,0,0,0,0,2.087L13.395,27.567A1.548,1.548,0,0,0,14.474,28Z","transform":"translate(0 0)","fill":"#fff"}));
}

ChevronLeft.defaultProps = {"width":"16","height":"28","viewBox":"0 0 16 28"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
